var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteAddNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19C1 9.059 9.059 1 19 1s18 8.059 18 18-8.059 18-18 18S1 28.941 1 19z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.325 16.468s-.543 6.735-.858 9.572c-.15 1.355-.987 2.15-2.358 2.174-2.61.047-5.221.05-7.83-.005-1.318-.027-2.141-.83-2.288-2.162-.317-2.862-.857-9.579-.857-9.579M27.708 13.24H10.75M24.44 13.24a1.648 1.648 0 01-1.614-1.324l-.243-1.216a1.28 1.28 0 00-1.237-.95h-4.233a1.28 1.28 0 00-1.237.95l-.243 1.216a1.648 1.648 0 01-1.615 1.324",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36C9.611 36 2 28.389 2 19H0c0 10.493 8.507 19 19 19v-2zm17-17c0 9.389-7.611 17-17 17v2c10.493 0 19-8.507 19-19h-2zM19 2c9.389 0 17 7.611 17 17h2C38 8.507 29.493 0 19 0v2zm0-2C8.507 0 0 8.507 0 19h2C2 9.611 9.611 2 19 2V0z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconDeleteAddNew;